import $ from 'jquery';
import BaseComponent from './baseComponent';

/**
 * Set correct size for image-full-width field.
 */
export default class ImageFullResizer extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);

    this.imageIdentifier = options.imageIdentifier || null;

    return this;
  }

  setImageSize() {
    const $images = $(this.imageIdentifier);
    const windowWidth = $(window).width();
    const windowHeight = $(window).height();
    const headerHeight = $('.page-header').height();
    const maxHeight = windowHeight - headerHeight;

    $.each($images, (index, imageBox) => {
      const $imageBox = $(imageBox);
      const image = $imageBox.find('.image');
      const $wrapper = $($imageBox.find('.imagewrapper'));
      const { naturalHeight } = image[0];
      const { naturalWidth } = image[0];
      const height = (windowWidth * naturalHeight) / naturalWidth;

      $imageBox.height('');
      $wrapper.height('');

      if (height < maxHeight) {
        $imageBox.height(height);
        $wrapper.height(height);
      }
    });
  }

  /**
     * Initialize function
     */
  init() {
    this.setImageSize();
  }

  updateOnResize() {
    this.setImageSize();
  }
}
